import {Tab} from '@/types/components'
import {PlugIcon} from '@sanity/icons'
import {OrgTokensTab} from '../../org/api/tokens/OrgTokensTab'
import {FunctionsSettings} from '../../project/api/functionsSettings'
import {AgentActionSettings} from '../../project/api/agentActionsSettings'
import {GetOrgTabsOptions} from '../types'

export function getApiTab(featureFlags?: GetOrgTabsOptions['featureFlags']): Tab {
  const tokensHeading: Tab[] = []
  if (featureFlags?.api_tokens) {
    tokensHeading.push({
      title: 'Tokens',
      path: 'tokens',
      component: OrgTokensTab,
      description:
        'Tokens are used to authenticate apps and scripts to deploy Studios and SDK apps.',
      permissions: [{permissionName: 'sanity.organization.tokens', grantName: 'read'}],
    })
  }

  return {
    title: 'API',
    icon: PlugIcon,
    path: 'api',
    headings: [
      {
        title: 'Functions',
        description: 'Hosts that can connect to the project API.',
        path: 'functions',
        isRoot: true,
        component: FunctionsSettings,
      },
      {
        title: 'Agent Actions',
        description: 'Hosts that can connect to the project API.',
        path: 'agent-actions',
        component: AgentActionSettings,
      },
      ...tokensHeading,
    ],
  }
}
